<template>
    <div class="goods-detail-container" v-loading="loading">
        <el-page-header @back="goBack"></el-page-header>
        <iframe v-if="productData.goods_attribute && productData.goods_attribute.length > 0" ref="personalized" :src="`${(domain.includes('localhost') || domain.includes('cmoffer-pat')) && 'https://cmoffer-sit.loratech.cn' || ''}/personalized/index.html?platform=cmoffer&sku=${productData.goods_attribute[0].sku}${domain !== 'app.cmoffer.com' && `&debug=${domain.includes('cmoffer-pat') && 2 || 1}` || ''}`" style="width: 100%; height: calc(100% - 24px);" frameborder="0" />
        <choosePlatform
            :choosePlatformVisible.sync="choosePlatformVisible"
            :productData="productData"
            @choosePlatform="choosePlatform"
        ></choosePlatform>
        <shopifyListing
            :shopifyListingVisible.sync="shopifyListingVisible"
            :productData="productData"
            :platform_id="platform_id"
        ></shopifyListing>
        <shoplineListing
            :shoplineListingVisible.sync="shoplineListingVisible"
            :productData="productData"
            :platform_id="platform_id"
        ></shoplineListing>
        <!-- <generate :generateVisible.sync="generateVisible"></generate> -->
        <selectShop :id="id" :selectShopVisible.sync="selectShopVisible"></selectShop>
    </div>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapState } from "vuex";
import choosePlatform from "./choosePlatform.vue";
import shopifyListing from "./shopifyListing.vue";
import shoplineListing from "./shoplineListing.vue";
import selectShop from "./selectShop.vue";
//import generate from "@/common/components/generateDialog.vue";

export default {
    data() {
        return {
            id: "",
            combinationIsShow: false,
            productData: {},
            // checkActive: "",
            // previewImgSrc: "",
            // goodsAttributeIndex: 0,
            thumbIndex: 0,
            loading: false,
            choosePlatformVisible: false,
            shopifyListingVisible: false,
            shoplineListingVisible: false,
            selectShopVisible: false,
            qty: 1,
            addBtnLoading: false,
            //isDownload: false,
            platform_id: "",
            isWish: false,
            roleId: "",
            showDetailInfo: false,
            //generateVisible: false,
            collectionId: "",
            domain: document.domain
        };
    },
    methods: {
        goBack() {
            this.$router.push({
                path: "/goodsList",
            });
        },
        productDetail() {
            this.loading = true;
            cmofferApi.productDetail({}, "get", this.id).then((res) => {
                this.loading = false;
                if (res) {
                    this.loading = true
                    this.productData = res.data;
                    this.isWish = this.productData.flag == 1 ? true : false;
                    // 设置默认选中属性
                    // this.checkActive = this.productData.goods_attribute[0].id;
                    // this.previewImgSrc = this.productData.goods_attribute[0].images[0];
                }
            });
            // this.customizedSetting();
        },
        checkFn(item, i) {
            // this.checkActive = item.id;
            // this.previewImgSrc = this.productData.goods_attribute[i].images[0];
            // this.goodsAttributeIndex = i;
        },
        choiceThumb(item, i) {
            this.thumbIndex = i;
        },
        choosePlatform(item) {
            if (item.platform_id == 3 || item.platform_id == 4) {
                this.shopifyListingVisible = true; 
            }else if(item.platform_id == 8){
                this.shoplineListingVisible = true; 
            }
            this.tableItem = item.tableItem;
            this.platform_id = item.platform_id;
        },
        publishToStore() {
            this.choosePlatformVisible = true;
        },
        addShoppingCart(data) {
            cmofferApi
                .addShoppingCart(
                    data,
                    "post"
                )
                .then((res) => {
                    this.addBtnLoading = false;
                    if (res.errcode == 0) {
                        this.$ga.event("ecommerce", "add_to_cart");
                        this.$message.success(
                            this.$i18n.locale == "zh"
                                ? "加入购物车成功"
                                : "Added successfully!"
                        );
                        let cartNum = +sessionStorage.getItem("CARTNUM") + data.qty;
                        this.$store.commit("SETCARTNUM", cartNum);
                        setTimeout(() => {
                            this.$refs.personalized && this.$refs.personalized.contentWindow.postMessage('reload', '*')
                        }, 1000)
                    } else {
                        this.$message.error(res.errmsg);
                    }
                });
        },
        download() {
            this.selectShopVisible = true;
            console.log('test')
            // cmofferApi.download({ id: this.id }, "get").then((res) => {
            //     // console.log(res);
            //     if (res.errcode == 0) {
            //         this.isDownload = true;
            //         this.generateVisible = true;
            //     }
            // });
        },
        addToWish() {
            cmofferApi
                .collectionList(
                    {
                        id: this.id,
                    },
                    "post"
                )
                .then((res) => {
                    this.isWish = !this.isWish;
                    if (res) {
                        this.$message.success(
                            this.$i18n.locale == "zh" ? "成功" : "Success"
                        );
                        this.collectionId = res.id;
                        this.$refs.personalized && this.$refs.personalized.contentWindow.postMessage(`wishListed-${this.isWish}`, '*')
                    }
                });
        },
        async initialize() {
            // this.id = this.$route.query.id;
            this.roleId = localStorage.getItem("roleId");
            this.productDetail();
        },
        detailLoaded() {
            this.loading = false
            setTimeout(() => {
                this.$refs.personalized && this.$refs.personalized.contentWindow.postMessage(`wishListed-${this.isWish}`, '*')}, 500)
        },
        receiveMessage: (event) => {
            const { origin, data } = event
            if (!origin.includes('localhost') && !origin.includes('cmoffer'))
                return;

            if (data) {
                if (data.constructor === String) {
                    data.startsWith('loaded:') && window.detailLoaded()
                    || data === 'publishToStore' && window.publishToStore()
                    || data === 'addToWish' && window.addToWish()
                    || data === 'download' && window.download()
                } else {
                    const { goods_id, goods_name, qty, sku } = data
                    if (goods_id && goods_name && qty && sku) {
                        window.addShoppingCart(data)
                    }
                }
            }

        }
    },
    computed: {
        ...mapState({}),
        height() {
            return `calc(100% - 120px${
                (this.hasSearchCondition ? " - 32px" : " - 0px") || ""
            })`;
        },
    },
    components: {
        choosePlatform,
        shopifyListing,
        shoplineListing,
        //generate,
        selectShop,
    },
    mounted() {
        const { id } = this.$route.query
        if (!id) return this.$router.push({
            path: '/goodsList'
        })

        this.id = id.toString();
        window.detailLoaded = this.detailLoaded
        window.publishToStore = this.publishToStore
        window.addToWish = this.addToWish
        window.download = this.download
        window.addShoppingCart = this.addShoppingCart

        window.addEventListener('message', this.receiveMessage, false)
    },
    beforeDestroy() {
        window.removeEventListener('message', this.receiveMessage)
    },
    watch: {
        $route: {
            handler: function(to, from) {
                if (to.query.id && (!from.query.id || to.query.id !== from.query.id)) {
                    this.id = to.query.id.toString()
                }
            }
        },
        id: {
            handler: function (nv, ov) {
                this.initialize();
            }
        }
    }
};

</script>

<style lang="scss" scoped>
.goods-detail-container {
    padding: 0 20px 0px 30px;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    ::v-deep .el-page-header {
        .el-page-header__left {
            .el-icon-back {
                font-weight: 600;
            }
            .el-page-header__title {
                font-size: 16px;
                font-weight: 600;
            }
            &::after {
                display: none;
            }
        }
    }

    ::v-deep .breadcrumb{
        margin: 5px 0 0 0;
        .el-breadcrumb__inner.is-link{
            font-weight: normal;
            color: #606266;
            &:hover{
                color: $color-primary;
                text-decoration: underline;
            }
        }
    }
}
</style>
